import { VisitRow } from "../../api/visit.type";
import MedicalRecordSummaryCard from "../medical-records/medical-record-summary-card";
import { formatTimeStampToHumanReadableDate } from "../utls/time";
import { pickRecordValue } from "#/lib/medicalRecords";

type VisitSummaryCardProps = {
  visit: VisitRow;
  onClick?: () => void;
};

const formatDate = (value?: string | null) => {
  if (!value) return undefined;
  try {
    return formatTimeStampToHumanReadableDate(value);
  } catch {
    return undefined;
  }
};

export function VisitSummaryCard({ visit, onClick }: VisitSummaryCardProps) {
  const providerName = pickRecordValue<string>(visit as any, [
    "visit_provider_name",
    "visitProviderName",
  ]);
  const title = providerName || pickRecordValue<string>(visit as any, [
    "visit_type",
    "visitType",
  ]) || "Visit";

  const subtitle = pickRecordValue<string>(visit as any, [
    "visit_location",
    "visitLocation",
    "visit_provider_specialty",
    "visitProviderSpecialty",
  ]);

  const status = pickRecordValue<string>(visit as any, [
    "visit_status",
    "visitStatus",
  ]);

  const meta = [
    {
      label: "Date",
      value: formatDate(
        pickRecordValue<string>(visit as any, ["visit_date", "visitDate"])
      ),
    },
    {
      label: "Type",
      value: pickRecordValue<string>(visit as any, ["visit_type", "visitType"]),
    },
  ];

  return (
    <MedicalRecordSummaryCard
      title={title}
      subtitle={subtitle}
      status={status}
      statusTone={status?.toLowerCase() === "completed" ? "success" : "default"}
      meta={meta}
      onClick={onClick}
    />
  );
}

export default VisitSummaryCard;
